// src/components/CarrinhoResumo.js
import React from 'react';
import './CarrinhoResumo.css'; // Vamos criar este CSS mais tarde

function CarrinhoResumo({ total, onFinalizarPedido }) {
  return (
    <div className="carrinho-resumo">
      <h3>Total: R$ {total.toFixed(2)}</h3>
      <button className="finalizar-pedido-btn" onClick={onFinalizarPedido} disabled={total === 0}>
        Finalizar Pedido
      </button>
    </div>
  );
}

export default CarrinhoResumo;